export default "__VITE_ASSET__BMk5qYsP__"